export const getStringWidth = (str, style = 'font-size:14px;') => {
  if (!str) {
    return new Error('参数1为空')
  }
  const text1 = document.createElement('div')
  text1.setAttribute('style', `visibility:hidden;${style}`)
  text1.innerHTML = str.slice(0, 1)
  document.body.appendChild(text1)
  const heightLine1 = text1.clientHeight
  const WidthLine1 = text1.clientWidth
  text1.innerHTML = str
  const height = text1.clientHeight
  const width = text1.clientWidth
  document.body.removeChild(text1)

  return {
    height,
    width,
    heightLine1,
    WidthLine1
  }
}
